import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function ConfirmModal({
  isOpen,
  toggle,
  onConfirm,
  title,
  message,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="custom-confirm-modal"
    >
      <ModalHeader toggle={toggle}>{title || 'Are you sure?'}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button className="loyal-btn-dark" color="primary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
}
